import { TypeAnimation } from "react-type-animation";

const AirdropHeroSection = ({ staticData }: { staticData: any }) => {
  return (
    <div className="!pt-12">
      <div className="max-w-[1420px] mx-auto px-[5vw] lg:px-6 flex flex-col-reverse lg:flex-row justify-between items-center gap-5 xl:gap-10 2xl:gap-14">
        <div className="w-full lg:w-1/2 flex flex-col items-start justify-center gap-6 lg:gap-9">
          <div>
            <TypeAnimation
              className="font-Azonix text-[31px] xs:text-4xl sm:text-[44px] xl:text-[52px] text-text-primary text-left whitespace-pre-line block"
              sequence={[
                "A",
                1000,
                `AIRDROP CENTER`,
                1000,
                "A",
                1000,
                `AIRDROP CENTER`,
                1000,
              ]}
              wrapper="span"
              speed={30}
              repeat={Infinity}
            />
            <div className="mt-4 xl:w-5/6 font-Montserrat text-text-secondary text-base text-left">
              Claim free tokens with our latest airdrops. Join campaigns,
              complete simple tasks, and earn crypto rewards - fast, fair, and
              secure!
            </div>
          </div>
          <div className="w-full flex gap-4 items-center font-Montserrat font-semibold text-left">
            <div className="w-1/2 sm:w-[200px] bg-backgroundWhite rounded-lg p-3 hover:bg-customBlue-500 group">
              <div className="text-base text-text-primary uppercase group-hover:text-white">
                Campaigns
              </div>
              <div className="mt-3 text-customBlue-500 text-[32px] leading-6 group-hover:text-white">
                {staticData?.total_airdrops}
              </div>
            </div>
            <div className="w-1/2 sm:w-[200px] bg-backgroundWhite rounded-lg p-3 hover:bg-customBlue-500 group">
              <div className="text-base text-text-primary uppercase group-hover:text-white">
                Total Rewards
              </div>
              <div className="mt-3 text-customBlue-500 text-[32px] leading-6 group-hover:text-white">
                {staticData?.total_airdrop_rewards}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-3/4 lg:w-1/2">
          <img
            src="/images/airdrop-hero-img.png"
            alt="airdrop-hero-vector"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default AirdropHeroSection;
